import slice from "./storeCostsSlice";

export default slice.reducer;
